// extracted by mini-css-extract-plugin
export default {"container":"videosOverlay__container__Y_Wvu"};